import { render, staticRenderFns } from "./WidgetsSelectorDialog.vue?vue&type=template&id=6d43b11e&"
import script from "./WidgetsSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./WidgetsSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports